import { defineComponent as _defineComponent } from 'vue'
import SvgArrow from "@/assets/icons/arrow-down.svg";
import { ref } from "vue";
import BaseButtonV2 from "@/components-UI/buttons/BaseButtonV2.vue";

export type FooterBulkActionsItem = {
    icon: SVGElement;
    text: string;
    action: () => void;
}

interface Props {
    items: FooterBulkActionsItem[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FooterBulkActions',
  props: {
    items: null
  },
  setup(__props: any) {

const props = __props as {
    items: FooterBulkActionsItem[]
}



// -- dropdown
const isShowDropdown = ref(false);
const toggleDropdown = () => {
    isShowDropdown.value = !isShowDropdown.value;
};
const closeDropdown = () => {
    if (!isShowDropdown.value) return;
    isShowDropdown.value = false;
};
const doAction = (action: () => void) => {
    action();
    closeDropdown();
};

return { __sfc: true,props, isShowDropdown, toggleDropdown, closeDropdown, doAction, SvgArrow, BaseButtonV2 }
}

})